module.exports = __webpack_public_path__ + "static/media/legge-68.805ce059.odt";